import type Message from "owa-service/lib/contract/Message";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import getListViewStore from "owa-mail-list-store/lib/store/Store";
import { ReactionsOnMailListItemContainer } from "owa-mail-list-reactions-view";
import mailStore from "owa-mail-store/lib/store/Store";
import type { JSX } from "react";

export interface renderReactionsProps {
    latestItemId: string;
    reactionsContainerClassName: string;
    rowId: string;
    tableViewId: string;
}
export default function renderReactions(params: renderReactionsProps): JSX.Element | null {
    const { latestItemId, reactionsContainerClassName, rowId, tableViewId } = params;
    
    const tableView = getListViewStore().tableViews.get(tableViewId);
    const isItemView = tableView?.tableQuery.listViewType === 1;
    const item = isItemView ? mailStore().items.get(rowId) : mailStore().items.get(latestItemId);
    
    const reactionsForRowId = getListViewStore().reactionInformationByRowId.get(rowId)?.reactions ?? [];
    
    const reactionsForRow = (reactionsForRowId?.length ?? 0) > 0
        ? reactionsForRowId
        : ((item as Message)?.Reactions ?? []);
    
    if (reactionsForRow.length === 0) {
        return null;
    }
    
    return (<div className={reactionsContainerClassName}>
            <ReactionsOnMailListItemContainer message={item as Message} reactionsForRowId={reactionsForRow}/>
        </div>);
}
